import React, { useEffect, useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';

// MahilaMandiCreateBasket.jsx
// A self-contained, responsive, modern shopping-cart style React component
// Uses Tailwind CSS classes (assumes Tailwind is available in the project)
// Default export is the React component

// ---------------------- Dummy product data ----------------------
const PRODUCTS = [
  {
    id: 'wp1',
    name: 'Homemade Mango Pickle (250g Jar)',
    category: 'Pickles & Preserves',
    unit: 'jar',
    unitPrice: 150,
    stock: 100,
    img: null,
    seasonal: false,
  },
  {
    id: 'wp2',
    name: 'Spicy Lemon Pickle (200g Jar)',
    category: 'Pickles & Preserves',
    unit: 'jar',
    unitPrice: 120,
    stock: 80,
    img: null,
    seasonal: false,
  },
  {
    id: 'wp3',
    name: 'Monsoon Garlic Pickle (180g Jar)',
    category: 'Pickles & Preserves',
    unit: 'jar',
    unitPrice: 110,
    stock: 60,
    img: null,
    seasonal: 'Monsoon',
  },
  {
    id: 'wp4',
    name: 'Diwali Mixed Fruit Jam (300g Jar)',
    category: 'Pickles & Preserves',
    unit: 'jar',
    unitPrice: 180,
    stock: 90,
    img: null,
    seasonal: 'Diwali',
  },
  {
    id: 'wp5',
    name: 'Lavender Handmade Soap (100g Bar)',
    category: 'Handmade Soaps',
    unit: 'bar',
    unitPrice: 80,
    stock: 200,
    img: null,
    seasonal: false,
  },
  {
    id: 'wp6',
    name: 'Rose Geranium Soap (100g Bar)',
    category: 'Handmade Soaps',
    unit: 'bar',
    unitPrice: 90,
    stock: 150,
    img: null,
    seasonal: false,
  },
  {
    id: 'wp7',
    name: 'Winter Cinnamon Soap (100g Bar)',
    category: 'Handmade Soaps',
    unit: 'bar',
    unitPrice: 95,
    stock: 120,
    img: null,
    seasonal: 'Winter',
  },
  {
    id: 'wp8',
    name: 'Summer Aloe Vera Soap (100g Bar)',
    category: 'Handmade Soaps',
    unit: 'bar',
    unitPrice: 85,
    stock: 140,
    img: null,
    seasonal: 'Summer',
  },
  {
    id: 'wp9',
    name: 'Oatmeal Cookies Pack (200g)',
    category: 'Baked Goods',
    unit: 'pack',
    unitPrice: 200,
    stock: 150,
    img: null,
    seasonal: false,
  },
  {
    id: 'wp10',
    name: 'Chocolate Brownies Pack (150g)',
    category: 'Baked Goods',
    unit: 'pack',
    unitPrice: 180,
    stock: 120,
    img: null,
    seasonal: false,
  },
  {
    id: 'wp11',
    name: 'Diwali Besan Ladoo Pack (250g)',
    category: 'Baked Goods',
    unit: 'pack',
    unitPrice: 220,
    stock: 110,
    img: null,
    seasonal: 'Diwali',
  },
  {
    id: 'wp12',
    name: 'Christmas Gingerbread Cookies (200g)',
    category: 'Baked Goods',
    unit: 'pack',
    unitPrice: 210,
    stock: 70,
    img: null,
    seasonal: 'Christmas',
  },
  {
    id: 'wp13',
    name: 'Herbal Tea Blend (100g Pack)',
    category: 'Herbal Teas',
    unit: 'pack',
    unitPrice: 250,
    stock: 80,
    img: null,
    seasonal: false,
  },
  {
    id: 'wp14',
    name: 'Chamomile Mint Tea (100g Pack)',
    category: 'Herbal Teas',
    unit: 'pack',
    unitPrice: 220,
    stock: 90,
    img: null,
    seasonal: false,
  },
  {
    id: 'wp15',
    name: 'Winter Masala Chai (100g Pack)',
    category: 'Herbal Teas',
    unit: 'pack',
    unitPrice: 240,
    stock: 100,
    img: null,
    seasonal: 'Winter',
  },
  {
    id: 'wp16',
    name: 'Summer Iced Hibiscus Tea (100g Pack)',
    category: 'Herbal Teas',
    unit: 'pack',
    unitPrice: 230,
    stock: 85,
    img: null,
    seasonal: 'Summer',
  },
  {
    id: 'wp17',
    name: 'Embroidered Cotton Handkerchief',
    category: 'Textiles',
    unit: 'pcs',
    unitPrice: 100,
    stock: 120,
    img: null,
    seasonal: false,
  },
  {
    id: 'wp18',
    name: 'Handwoven Cotton Scarf',
    category: 'Textiles',
    unit: 'pcs',
    unitPrice: 350,
    stock: 60,
    img: null,
    seasonal: false,
  },
  {
    id: 'wp19',
    name: 'Winter Woolen Shawl (Handwoven)',
    category: 'Textiles',
    unit: 'pcs',
    unitPrice: 450,
    stock: 40,
    img: null,
    seasonal: 'Winter',
  },
  {
    id: 'wp20',
    name: 'Summer Cotton Kurta Fabric (2m)',
    category: 'Textiles',
    unit: 'm',
    unitPrice: 300,
    stock: 50,
    img: null,
    seasonal: 'Summer',
  },
  {
    id: 'wp21',
    name: 'Beaded Earrings Set',
    category: 'Jewelry',
    unit: 'set',
    unitPrice: 200,
    stock: 100,
    img: null,
    seasonal: false,
  },
  {
    id: 'wp22',
    name: 'Clay Beaded Necklace',
    category: 'Jewelry',
    unit: 'pcs',
    unitPrice: 280,
    stock: 70,
    img: null,
    seasonal: false,
  },
  {
    id: 'wp23',
    name: 'Diwali Jhumka Earrings (Silver Plated)',
    category: 'Jewelry',
    unit: 'set',
    unitPrice: 250,
    stock: 80,
    img: null,
    seasonal: 'Diwali',
  },
  {
    id: 'wp24',
    name: 'Rakhi Thread Bracelet Set',
    category: 'Jewelry',
    unit: 'set',
    unitPrice: 150,
    stock: 60,
    img: null,
    seasonal: 'Raksha Bandhan',
  },
  {
    id: 'wp25',
    name: 'Scented Soy Candle (200g)',
    category: 'Candles',
    unit: 'pcs',
    unitPrice: 250,
    stock: 110,
    img: null,
    seasonal: false,
  },
  {
    id: 'wp26',
    name: 'Lavender Essential Oil Candle (150g)',
    category: 'Candles',
    unit: 'pcs',
    unitPrice: 220,
    stock: 95,
    img: null,
    seasonal: false,
  },
  {
    id: 'wp27',
    name: 'Diwali Diya Scented Candle (100g)',
    category: 'Candles',
    unit: 'pcs',
    unitPrice: 180,
    stock: 130,
    img: null,
    seasonal: 'Diwali',
  },
  {
    id: 'wp28',
    name: 'Christmas Pine Forest Candle (200g)',
    category: 'Candles',
    unit: 'pcs',
    unitPrice: 260,
    stock: 65,
    img: null,
    seasonal: 'Christmas',
  },
  {
    id: 'wp29',
    name: 'Handcrafted Clay Mug (300ml)',
    category: 'Pottery',
    unit: 'pcs',
    unitPrice: 300,
    stock: 50,
    img: null,
    seasonal: false,
  },
  {
    id: 'wp30',
    name: 'Terracotta Flower Pot (Medium)',
    category: 'Pottery',
    unit: 'pcs',
    unitPrice: 180,
    stock: 75,
    img: null,
    seasonal: false,
  },
  {
    id: 'wp31',
    name: 'Monsoon Rain Vase (Clay)',
    category: 'Pottery',
    unit: 'pcs',
    unitPrice: 220,
    stock: 55,
    img: null,
    seasonal: 'Monsoon',
  },
  {
    id: 'wp32',
    name: 'Holi Color Bowl (Terracotta)',
    category: 'Pottery',
    unit: 'pcs',
    unitPrice: 160,
    stock: 70,
    img: null,
    seasonal: 'Holi',
  },
];

// ---------------------- Combo / bundle data ----------------------
const BUNDLES = [
  {
    id: 'wb1',
    name: 'Self-Care Wellness Combo',
    description: 'Lavender Soap 2 bars + Herbal Tea 1 pack',
    bundleItems: [
      { productId: 'wp5', qty: 2 },
      { productId: 'wp13', qty: 1 },
    ],
    // bundle price gives a discount vs buying separately
    price: 2 * 80 + 250 - 50, // 20% discount
  },
  {
    id: 'wb2',
    name: 'Artisan Kitchen Pack',
    description: 'Mango Pickle 1 jar + Oatmeal Cookies 1 pack',
    bundleItems: [
      { productId: 'wp1', qty: 1 },
      { productId: 'wp9', qty: 1 },
    ],
    price: 150 + 200 - 30, // 10% discount
  },
  {
    id: 'wb3',
    name: 'Gift for Her Combo',
    description: 'Embroidered Handkerchief 1 pc + Beaded Earrings 1 set + Scented Candle 1 pc',
    bundleItems: [
      { productId: 'wp17', qty: 1 },
      { productId: 'wp21', qty: 1 },
      { productId: 'wp25', qty: 1 },
    ],
    price: 100 + 200 + 250 - 70, // 15% discount
  },
  {
    id: 'wb4',
    name: 'Home Decor Bundle',
    description: 'Handwoven Scarf 1 pc + Terracotta Flower Pot 1 pc + Clay Mug 1 pc',
    bundleItems: [
      { productId: 'wp18', qty: 1 },
      { productId: 'wp30', qty: 1 },
      { productId: 'wp29', qty: 1 },
    ],
    price: 350 + 180 + 300 - 80, // 12% discount
  },
  {
    id: 'wb5',
    name: 'Diwali Festive Pack',
    description: 'Diwali Mixed Fruit Jam 1 jar + Diwali Besan Ladoo 1 pack + Diwali Jhumka Earrings 1 set + Diwali Diya Candle 1 pc',
    bundleItems: [
      { productId: 'wp4', qty: 1 },
      { productId: 'wp11', qty: 1 },
      { productId: 'wp23', qty: 1 },
      { productId: 'wp27', qty: 1 },
    ],
    price: 180 + 220 + 250 + 180 - 100, // 20% discount
  },
  {
    id: 'wb6',
    name: 'Winter Warmth Bundle',
    description: 'Winter Woolen Shawl 1 pc + Winter Cinnamon Soap 1 bar + Winter Masala Chai 1 pack',
    bundleItems: [
      { productId: 'wp19', qty: 1 },
      { productId: 'wp7', qty: 1 },
      { productId: 'wp15', qty: 1 },
    ],
    price: 450 + 95 + 240 - 90, // 15% discount
  },
  {
    id: 'wb7',
    name: 'Summer Refresh Combo',
    description: 'Summer Aloe Vera Soap 1 bar + Summer Iced Hibiscus Tea 1 pack + Summer Cotton Kurta Fabric 2m',
    bundleItems: [
      { productId: 'wp8', qty: 1 },
      { productId: 'wp16', qty: 1 },
      { productId: 'wp20', qty: 2 },
    ],
    price: 85 + 230 + 2 * 300 - 80, // 10% discount
  },
  {
    id: 'wb8',
    name: 'Monsoon Essentials Pack',
    description: 'Monsoon Garlic Pickle 1 jar + Monsoon Rain Vase 1 pc',
    bundleItems: [
      { productId: 'wp3', qty: 1 },
      { productId: 'wp31', qty: 1 },
    ],
    price: 110 + 220 - 40, // 15% discount
  },
  {
    id: 'wb9',
    name: 'Holiday Baking Kit',
    description: 'Chocolate Brownies Pack 1 + Christmas Gingerbread Cookies 1 pack + Rose Geranium Soap 1 bar (gift wrap)',
    bundleItems: [
      { productId: 'wp10', qty: 1 },
      { productId: 'wp12', qty: 1 },
      { productId: 'wp6', qty: 1 },
    ],
    price: 180 + 210 + 90 - 60, // 15% discount
  },
  {
    id: 'wb10',
    name: 'Festival Jewelry & Candle Set',
    description: 'Rakhi Thread Bracelet Set 1 + Clay Beaded Necklace 1 pc + Christmas Pine Forest Candle 1 pc',
    bundleItems: [
      { productId: 'wp24', qty: 1 },
      { productId: 'wp22', qty: 1 },
      { productId: 'wp28', qty: 1 },
    ],
    price: 150 + 280 + 260 - 80, // 12% discount
  },
];

const ROLE_DISCOUNTS = {
  consumer: 0,
  'area-coordinator': 8, // percent
  'cnf-agent': 5,
  wholesaler: 12,
  retailer: 6,
};

// ---------------------- Helpers ----------------------
const formatCurrency = (v) => `₹${Number(v).toFixed(2)}`;

const getProductById = (id) => PRODUCTS.find((p) => p.id === id);

const STORAGE_KEY = 'agri_link_myveg_basket_v1';

// ---------------------- Component ----------------------
export default function MahilaMandiCreateBasket() {
  // role
  const [role, setRole] = useState('consumer');

  // filtering
  const [search, setSearch] = useState('');
  const [category, setCategory] = useState('All');

  // product card quantity state (before adding to cart)
  const [preQty, setPreQty] = useState({});
  const [errors, setErrors] = useState({});

  // cart state
  const [cart, setCart] = useState([]);

  // coupon code
  const [coupon, setCoupon] = useState('');
  const [couponApplied, setCouponApplied] = useState(null);

  // load from localStorage
  useEffect(() => {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (raw) {
      try {
        const parsed = JSON.parse(raw);
        setCart(parsed.cart || []);
        setRole(parsed.role || 'consumer');
      } catch (e) {
        // ignore parse errors
      }
    }
  }, []);

  // save cart on change
  useEffect(() => {
    localStorage.setItem(
      STORAGE_KEY,
      JSON.stringify({ cart, role, updatedAt: new Date().toISOString() })
    );
  }, [cart, role]);

  // derived lists
  const categories = ['All', ...Array.from(new Set(PRODUCTS.map((p) => p.category)))];

  const visibleProducts = PRODUCTS.filter((p) => {
    const matchesCategory = category === 'All' || p.category === category;
    const matchesSearch =
      search.trim() === '' || p.name.toLowerCase().includes(search.trim().toLowerCase());
    return matchesCategory && matchesSearch;
  });

  // ---------------------- Validation ----------------------
  const validateQty = (product, qtyRaw) => {
    const unit = product.unit;
    if (qtyRaw === '' || qtyRaw === null || qtyRaw === undefined) {
      return 'Enter quantity';
    }
    // allow decimals for kg
    const num = Number(qtyRaw);
    if (Number.isNaN(num) || num <= 0) return 'Quantity must be > 0';
    if (unit === 'pcs' && !Number.isInteger(num)) return 'Use whole numbers for pcs';
    if (num > product.stock) return `Only ${product.stock} ${unit} available`;
    // for kg allow up to 2 decimals
    if (unit === 'kg') {
      const parts = qtyRaw.toString().split('.');
      if (parts[1] && parts[1].length > 2) return 'Max 2 decimal places for kg';
    }
    return null;
  };

  // ---------------------- Cart Operations ----------------------
  const addProductToCart = (productId) => {
    const product = getProductById(productId);
    const qtyRaw = preQty[productId] ?? '';
    const err = validateQty(product, qtyRaw);
    setErrors((s) => ({ ...s, [productId]: err }));
    if (err) return;
    const qty = Number(qtyRaw);

    setCart((c) => {
      const existingIndex = c.findIndex((it) => !it.isBundle && it.productId === productId);
      if (existingIndex >= 0) {
        const copy = [...c];
        copy[existingIndex] = {
          ...copy[existingIndex],
          qty: Number((copy[existingIndex].qty + qty).toFixed(3)),
          subtotal: Number(((copy[existingIndex].qty + qty) * product.unitPrice).toFixed(2)),
        };
        return copy;
      }
      const item = {
        id: `ci_${Date.now()}_${Math.random().toString(36).slice(2, 9)}`,
        productId: product.id,
        name: product.name,
        unit: product.unit,
        qty,
        unitPrice: product.unitPrice,
        subtotal: Number((qty * product.unitPrice).toFixed(2)),
        isBundle: false,
      };
      return [...c, item];
    });

    // reset qty for that product
    setPreQty((s) => ({ ...s, [productId]: '' }));
  };

  const addBundleToCart = (bundleId, bundleQtyRaw = 1) => {
    const bundle = BUNDLES.find((b) => b.id === bundleId);
    const qty = Number(bundleQtyRaw) || 1;
    if (qty <= 0) return;

    // Check stock availability for each item if needed
    for (const bi of bundle.bundleItems) {
      const prod = getProductById(bi.productId);
      if (!prod) continue;
      const required = bi.qty * qty;
      if (required > prod.stock) {
        alert(`Bundle cannot be added: insufficient stock for ${prod.name}`);
        return;
      }
    }

    setCart((c) => {
      const item = {
        id: `cb_${Date.now()}_${Math.random().toString(36).slice(2, 9)}`,
        bundleId: bundle.id,
        name: bundle.name,
        isBundle: true,
        qty,
        unitPrice: bundle.price,
        subtotal: Number((bundle.price * qty).toFixed(2)),
        bundleItems: bundle.bundleItems,
      };
      return [...c, item];
    });
  };

  const updateCartQty = (cartItemId, newQtyRaw) => {
    setCart((c) => {
      const copy = c.map((it) => ({ ...it }));
      const idx = copy.findIndex((it) => it.id === cartItemId);
      if (idx < 0) return c;
      const it = copy[idx];
      const num = Number(newQtyRaw);
      if (Number.isNaN(num) || num <= 0) return c; // ignore invalid
      // check stock if product item
      if (!it.isBundle) {
        const p = getProductById(it.productId);
        if (num > p.stock) {
          alert(`Only ${p.stock} ${p.unit} available for ${p.name}`);
          return c;
        }
        it.qty = it.unit === 'pcs' ? Math.floor(num) : Number(num.toFixed(3));
        it.subtotal = Number((it.qty * it.unitPrice).toFixed(2));
      } else {
        // bundle - no direct per-product stock check here (done at add)
        it.qty = Math.floor(num);
        it.subtotal = Number((it.qty * it.unitPrice).toFixed(2));
      }
      return copy;
    });
  };

  const removeCartItem = (cartItemId) => {
    setCart((c) => c.filter((it) => it.id !== cartItemId));
  };

  const clearCart = () => setCart([]);

  // ---------------------- Price calculations ----------------------
  const subtotal = cart.reduce((s, it) => s + Number(it.subtotal || 0), 0);
  const roleDiscountPercent = ROLE_DISCOUNTS[role] ?? 0;
  const roleDiscountAmount = (subtotal * roleDiscountPercent) / 100;
  const couponDiscountAmount = couponApplied ? couponApplied.amount || 0 : 0;
  const tax = Number(((subtotal - roleDiscountAmount - couponDiscountAmount) * 0.05).toFixed(2));
  const deliveryFee = subtotal >= 500 ? 0 : 30;
  const total = Number((subtotal - roleDiscountAmount - couponDiscountAmount + tax + deliveryFee).toFixed(2));

  // ---------------------- Coupon handling (dummy) ----------------------
  const handleApplyCoupon = () => {
    const code = coupon.trim().toUpperCase();
    if (!code) return alert('Enter coupon code');
    // dummy codes
    if (code === 'FRESH10') {
      setCouponApplied({ code, amount: Math.min(50, subtotal * 0.1), note: '10% off (max ₹50)' });
    } else if (code === 'DAIRY5') {
      setCouponApplied({ code, amount: Math.min(30, subtotal * 0.05), note: '5% off dairy' });
    } else {
      alert('Invalid coupon');
    }
  };

  const handleCheckout = () => {
    if (cart.length === 0) return alert('Cart is empty');
    // simple validation before checkout
    for (const it of cart) {
      if (!it.isBundle) {
        const p = getProductById(it.productId);
        if (it.qty > p.stock) {
          return alert(`Not enough stock for ${p.name}`);
        }
      } else {
        // bundle - check each subproduct
        for (const bi of it.bundleItems) {
          const p = getProductById(bi.productId);
          const needed = bi.qty * it.qty;
          if (needed > p.stock) return alert(`Bundle needs ${needed} ${p.unit} of ${p.name} but only ${p.stock} available`);
        }
      }
    }

    // simulate success
    alert(`Checkout successful! Total: ${formatCurrency(total)}\nRole discount: ${roleDiscountPercent}%`);
    // after checkout, you might want to reduce stock locally (dummy) and clear cart
    // reduce stock (dummy)
    const newProducts = PRODUCTS.map((p) => ({ ...p }));
    for (const it of cart) {
      if (!it.isBundle) {
        const p = newProducts.find((x) => x.id === it.productId);
        if (p) p.stock = Math.max(0, p.stock - it.qty);
      } else {
        for (const bi of it.bundleItems) {
          const p = newProducts.find((x) => x.id === bi.productId);
          if (p) p.stock = Math.max(0, p.stock - bi.qty * it.qty);
        }
      }
    }
    // NOTE: since PRODUCTS is a const above (dummy data), we are not persisting stock changes.

    clearCart();
    setCoupon('');
    setCouponApplied(null);
  };

  const loadSampleCart = () => {
    const sample = [
      {
        id: `ci_demo_1`,
        productId: 'wp1',
        name: 'Homemade Mango Pickle (250g Jar)',
        unit: 'jar',
        qty: 1,
        unitPrice: 150,
        subtotal: 150,
        isBundle: false,
      },
      {
        id: `cb_demo_1`,
        bundleId: 'wb2',
        name: 'Artisan Kitchen Pack',
        isBundle: true,
        qty: 1,
        unitPrice: BUNDLES.find((b) => b.id === 'wb2').price,
        subtotal: BUNDLES.find((b) => b.id === 'wb2').price,
        bundleItems: BUNDLES.find((b) => b.id === 'wb2').bundleItems,
      },
    ];
    setCart(sample);
  };

  const saveCartToServer = () => {
    // Dummy placeholder to show how you'd send cart to backend
    alert('Cart saved locally (dummy). When backend available, POST /api/cart with payload.');
    // console.log({ cart, role });
  };

  // ---------------------- Render ----------------------
  return (
    <div className="p-4 md:p-8 bg-green-600 min-h-screen">
      <div className="max-w-7xl mx-auto">
        <header className="flex flex-col md:flex-row md:items-center md:justify-between gap-4 mb-6">
          <div>
            <h1 className="text-2xl md:text-3xl font-extrabold text-yellow-200">MahilaMandi — Create Basket</h1>
            <p className="text-sm text-white mt-1">Build a basket — for Area Coordinator, CNF Agent, Wholesaler, Retailer or Consumer</p>
          </div>

          <div className="flex items-center gap-3">
            <label className="text-sm text-white h-10">Role</label>
            <select
              value={role}
              onChange={(e) => setRole(e.target.value)}
              className="px-3 py-2 rounded-lg border bg-white text-black text-sm h-10"
            >
              <option value="consumer">Consumer</option>
              <option value="area-coordinator">Area Coordinator</option>
              <option value="cnf-agent">CNF Agent</option>
              <option value="wholesaler">Wholesaler</option>
              <option value="retailer">Retailer</option>
            </select>

            <button
              onClick={() => {
                localStorage.removeItem(STORAGE_KEY);
                setCart([]);
                alert('Cleared saved cart');
              }}
              className="mt-4 ml-2 px-3 py-2 bg-white text-black rounded-lg border text-sm h-10"
            >
              Reset Saved
            </button>
          </div>
        </header>

        <section className="grid grid-cols-1 lg:grid-cols-12 gap-6">
          {/* Left: Products */}
          <div className="lg:col-span-8">
            <div className="flex flex-col md:flex-row md:items-center gap-3 mb-4">
              <input
                placeholder="Search products or bundles..."
                value={search}
                onChange={(e) => setSearch(e.target.value)}
                className="flex-1 px-4 py-2 rounded-lg border bg-white text-black h-10"
              />

              <select
                value={category}
                onChange={(e) => setCategory(e.target.value)}
                className="px-3 py-2 rounded-lg border bg-white text-black h-10"
              >
                {categories.map((c) => (
                  <option key={c} value={c}>{c}</option>
                ))}
              </select>

              <div className="flex gap-2 mt-4">
                <button
                  onClick={loadSampleCart}
                  className="px-4 py-2 bg-purple-800 text-white border rounded-lg text-sm h-10 w-full"
                >LoadSample</button>

                <button
                  onClick={saveCartToServer}
                  className="px-4 py-2 bg-blue-600 text-white rounded-lg text-sm shadow h-10 w-full"
                >Save Cart</button>
              </div>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              {visibleProducts.map((p) => (
                <div key={p.id} className="bg-gray-600 rounded-2xl p-4 shadow-sm border">
                  <div className="flex items-center gap-4">
                    <div className="w-20 h-20 rounded-lg bg-gray-100 flex items-center justify-center text-black text-xs">
                      {p.unit.toUpperCase()}
                    </div>
                    <div className="flex-1">
                      <div className="flex items-start justify-between">
                        <div>
                          <h3 className="font-semibold">{p.name}</h3>
                          <p className="text-xs text-white">{p.category}</p>
                        </div>
                        <div className="text-right">
                          <div className="text-sm font-bold text-white">{formatCurrency(p.unitPrice)} / {p.unit}</div>
                          <div className="text-xs text-white">Stock: {p.stock}</div>
                        </div>
                      </div>

                      <div className="mt-3 flex items-center gap-2">
                        <div className="flex items-center border rounded-lg overflow-hidden w-full">
                          <button
                            onClick={() => {
                              setPreQty((s) => ({ ...s, [p.id]: Math.max(0, Number((Number(s[p.id] || 0) - (p.unit === 'pcs' ? 1 : 0.25)).toFixed(3))) }));
                            }}
                            className="px-3 py-1 text-sm h-10"
                            aria-label={`decrease ${p.name}`}
                          >-</button>

                          <input
                            value={preQty[p.id] ?? ''}
                            onChange={(e) => setPreQty((s) => ({ ...s, [p.id]: e.target.value }))}
                            placeholder={p.unit === 'kg' ? '0.5' : '1'}
                            className="w-20 text-center px-2 py-1 text-sm h-10 text-black"
                          />

                          <button
                            onClick={() => {
                              setPreQty((s) => ({ ...s, [p.id]: Number((Number(s[p.id] || 0) + (p.unit === 'pcs' ? 1 : 0.25)).toFixed(3)) }));
                            }}
                            className="px-3 py-1 text-sm h-10"
                            aria-label={`increase ${p.name}`}
                          >+</button>
                        </div>

                        <button
                          onClick={() => addProductToCart(p.id)}
                          className="ml-2 px-4 py-2 bg-blue-600 text-white rounded-lg text-sm w-16"
                        >Add</button>

                        <div className="text-sm text-red-500 ml-3">{errors[p.id]}</div>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>

            <div className="mt-6">
              <h2 className="text-lg font-semibold mb-3">Combos & Bundles</h2>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                {BUNDLES.map((b) => (
                  <div key={b.id} className="bg-white rounded-2xl p-4 shadow-sm border">
                    <div className="flex items-start justify-between">
                      <div>
                        <h3 className="font-semibold text-blue-700">{b.name}</h3>
                        <p className="text-sm text-gray-500 mt-1">{b.description}</p>
                        <ul className="mt-2 text-xs text-gray-600 list-disc ml-5">
                          {b.bundleItems.map((it) => {
                            const prod = getProductById(it.productId);
                            return (
                              <li key={it.productId}>{prod ? prod.name : it.productId} — {it.qty} {prod ? prod.unit : ''}</li>
                            );
                          })}
                        </ul>
                      </div>
                      <div className="text-right">
                        <div className="font-bold text-lg">{formatCurrency(b.price)}</div>
                        <div className="text-xs text-gray-500">Bundle price</div>
                      </div>
                    </div>

                    <div className="mt-4 flex items-center gap-2">
                      <button
                        onClick={() => addBundleToCart(b.id, 1)}
                        className="px-4 py-2 bg-indigo-600 text-white rounded-lg text-sm"
                      >Add Bundle</button>

                      <button
                        onClick={() => {
                          // quick preview add 2
                          addBundleToCart(b.id, 2);
                        }}
                        className="px-3 py-2 bg-cyan-600 border rounded-lg text-sm"
                      >Add x2</button>

                    </div>
                  </div>
                ))}
              </div>
            </div>

          </div>

          {/* Right: Cart */}
          <aside className="lg:col-span-4">
            <div className="sticky top-6 bg-white p-4 rounded-2xl shadow border">
              <div className="flex items-center justify-between">
                <h2 className="text-lg font-semibold text-green-700">My Basket</h2>
                <div className="text-xs text-gray-500">{cart.length} items</div>
              </div>

              <div className="mt-3 h-64 overflow-auto">
                {cart.length === 0 && <div className="text-sm text-gray-500">Your basket is empty — add products or bundles.</div>}

                <ul className="space-y-3">
                  {cart.map((it) => (
                    <li key={it.id} className="flex items-start gap-3">
                      <div className="w-12 h-12 rounded-lg bg-gray-100 flex items-center justify-center text-xs">
                        {it.isBundle ? 'B' : it.unit?.toUpperCase?.() ?? ''}
                      </div>

                      <div className="flex-1">
                        <div className="flex items-start justify-between">
                          <div>
                            <div className="font-medium">{it.name}</div>
                            {it.isBundle && (
                              <div className="text-xs text-gray-500">Includes: {it.bundleItems.map((bi) => getProductById(bi.productId)?.name).join(', ')}</div>
                            )}
                          </div>

                          <div className="text-right">
                            <div className="font-semibold">{formatCurrency(it.unitPrice)}</div>
                            <div className="text-xs text-gray-500">Sub: {formatCurrency(it.subtotal)}</div>
                          </div>
                        </div>

                        <div className="mt-2 flex items-center gap-2">
                          <input
                            value={it.qty}
                            onChange={(e) => updateCartQty(it.id, e.target.value)}
                            className="w-20 px-2 py-1 border rounded-lg text-sm"
                          />

                          <button
                            onClick={() => removeCartItem(it.id)}
                            className="text-sm text-yellow-200 px-2 py-1"
                          >Remove</button>
                        </div>
                      </div>
                    </li>
                  ))}
                </ul>
              </div>

              <div className="mt-4 border-t pt-3">
                <div className="flex items-center gap-2">
                  <input
                    placeholder="Coupon code"
                    value={coupon}
                    onChange={(e) => setCoupon(e.target.value)}
                    className="flex-1 px-3 py-2 border rounded-lg text-sm"
                  />
                  <button onClick={handleApplyCoupon} className="px-3 py-2 bg-yellow-500 text-white rounded-lg text-sm">Apply</button>
                </div>

                {couponApplied && (
                  <div className="mt-2 text-sm text-green-700">Applied {couponApplied.code}: saved {formatCurrency(couponApplied.amount)}</div>
                )}

                <div className="mt-4 text-sm space-y-2">
                  <div className="flex justify-between"><div>Subtotal</div><div>{formatCurrency(subtotal)}</div></div>
                  <div className="flex justify-between"><div>Role Discount ({roleDiscountPercent}%)</div><div>-{formatCurrency(roleDiscountAmount)}</div></div>
                  <div className="flex justify-between"><div>Coupon</div><div>-{formatCurrency(couponDiscountAmount)}</div></div>
                  <div className="flex justify-between"><div>Tax (5%)</div><div>{formatCurrency(tax)}</div></div>
                  <div className="flex justify-between"><div>Delivery</div><div>{deliveryFee === 0 ? 'Free' : formatCurrency(deliveryFee)}</div></div>

                  <div className="flex justify-between font-bold mt-2 border-t pt-2"><div>Total</div><div>{formatCurrency(total)}</div></div>
                </div>

                <div className="mt-4 flex gap-2">
                  <button onClick={handleCheckout} className="flex-1 px-4 py-2 bg-green-600 text-white rounded-lg">Checkout</button>
                  <button onClick={clearCart} className="px-4 py-2 bg-indigo-600 border rounded-lg">Clear</button>
                </div>

              </div>
            </div>

            <div className="mt-4 text-xs text-gray-500">
              Tip: role selection applies a quick discount to demonstrate role-based pricing. When backend is ready, sync roles and pricing from server and replace localStorage with authenticated persistence.
            </div>
          </aside>
        </section>
      </div>
      {/* Footer inside root div */}
      <footer className="bg-green-700 text-white py-10 px-4 sm:px-6 md:px-20">
      <div className="flex flex-col md:flex-row justify-between items-center text-center md:text-left">
          <p className="text-sm">&copy; 2025 Think5Whys Global DeepTech Solutions. All rights reserved.</p>
          <div className="flex space-x-6 mt-4 md:mt-0 text-sm">
          <Link to="/about-us" className="text-white hover:text-green-400 transition">
              About
          </Link>
          <Link to="/privacy-policy" className="text-white hover:text-green-400 transition">
              Privacy Policy
          </Link>
          <Link to="/terms-of-use" className="text-white hover:text-green-400 transition">
              Terms of Use
          </Link>
          <Link to="/contact-us" className="text-white hover:text-green-400 transition">
              Contact
          </Link>
          </div>
      </div>
      </footer>
    </div>
  );
}